// state.js

export default {
    notificationList: [],
};
